"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Logo = require("../Logo.style");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Condensed = function Condensed(_ref) {
  var size = _ref.size,
    className = _ref.className,
    fillColor = _ref.fillColor,
    type = _ref.type,
    title = _ref.title;
  return /*#__PURE__*/_react.default.createElement(_Logo.LogoStyled, {
    className: className,
    "data-key": "max-logo",
    size: size,
    logoType: type,
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    title: title
  }, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("polygon", {
    fill: fillColor,
    points: "-4.03896783e-27 1.27897692e-13 5.4122169e-26 72 72 72 72 8.58280665e-28"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M35.096442,37.948399 L35.096442,37.948399 L34.1928841,37.948399 L33.9843707,37.948399 L33.9843707,38.1571561 L33.9843707,41.9843684 L33.9843707,42.1931255 L34.1928841,42.1931255 L35.1659465,42.1931255 C36.0695045,42.1931255 37.5290981,42.1931255 38.2936471,41.427683 C38.6411694,41.0797546 38.8496828,40.5926548 38.8496828,40.0359694 C38.8496828,39.479284 38.6411694,38.9921842 38.2936471,38.6442558 C37.5290981,37.948399 36.1390089,37.948399 35.096442,37.948399 L35.096442,37.948399 Z M34.9574331,33.5645012 C35.8609911,33.5645012 36.764549,33.4949155 37.3205847,32.9382301 C37.668107,32.5903017 37.8071159,32.1727876 37.8071159,31.6161022 C37.8071159,31.0594168 37.668107,30.6419027 37.3205847,30.36356 C36.764549,29.8068745 35.7914866,29.8068745 34.9574331,29.8068745 L34.7489197,29.8068745 L34.1928841,29.8068745 L33.9843707,29.8068745 L33.9843707,30.0156316 L33.9843707,33.2861585 L33.9843707,33.5645012 L34.1928841,33.5645012 L34.9574331,33.5645012 Z M25.6438356,47.2728801 L25.6438356,24.6575342 L36.2780178,24.6575342 C39.8227452,24.6575342 42.2554013,25.353391 43.7149949,26.7451046 C44.6880574,27.7193041 45.244093,29.1110177 45.244093,30.8506597 C45.244093,33.0078158 44.1320217,34.7474578 42.3249058,35.3041432 C42.3249058,35.3041432 41.8383746,35.5129002 41.2823389,35.5824859 L42.3249058,35.9304143 C44.1320217,36.5566854 46.3561644,38.0179847 46.3561644,41.218926 C46.3561644,45.7419951 42.0468879,47.3424658 38.0156293,47.3424658 L25.6438356,47.3424658 L25.6438356,47.2728801 Z",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
};
var _default = Condensed;
exports.default = _default;